import {
  getAllPhotosFromReviews,
  getReviewsAllPhotos,
  getReviewsPhotosModalCurrentShowed,
  isReviewsPhotosModalOpenedFromGallery,
  isReviewsPhotosModalShowed,
} from 'features/reviews/selectors';
import React from 'react';
import { connect } from 'react-redux';
import { RootReducer } from 'store/root-reducer';
import { Dispatch } from 'redux';
import { PhotosModal, PhotosModalProps } from 'common/components/photos-modal';
import { closePhotosModal, PictureSources, showPhoto } from 'features/reviews';
import {
  getHasMoreReviewsPhotos,
  getReviewsPhotosPagesCount,
} from 'features/reviews-photos/selectors/reviews-photos';
import { FETCH_REVIEWS_PHOTOS_PAGE } from 'features/reviews-photos/actions/reviews-photos';

const REVIEWS_PHOTOS_PER_PAGE = 10;

type ReviewsPhotosModalState = Pick<PhotosModalProps, 'photos' | 'showedPicture' | 'isShowed'> & {
  nextPhotosPageIndex: number;
  hasMorePhotos: boolean;
  isCheckedGallery: boolean;
};

type ReviewsPhotosModalProps = Omit<PhotosModalProps, 'atSSR'> & {
  fetchNextPhotos: (currentPage: number) => void;
  nextPhotosPageIndex: number;
  hasMorePhotos: boolean;
};

const ReviewsPhotosModal: React.FC<ReviewsPhotosModalProps> = ({
  breakpoint,
  photos,
  showedPicture,
  isShowed,
  setShowedPicture,
  onCloseModal,
  fetchNextPhotos,
  nextPhotosPageIndex,
  hasMorePhotos,
  isCheckedGallery,
  ...htmlProps
}) => {
  const [atSSR, setAtSSR] = React.useState<boolean>(true);
  React.useEffect(() => setAtSSR(false), []);
  return (
    <PhotosModal
      breakpoint={breakpoint}
      atSSR={atSSR}
      photos={photos}
      showedPicture={showedPicture}
      isShowed={isShowed}
      setShowedPicture={setShowedPicture}
      onCloseModal={onCloseModal}
      onRequestMorePhotos={hasMorePhotos ? () => fetchNextPhotos(nextPhotosPageIndex) : undefined}
      hasMorePhotos={hasMorePhotos}
      isCheckedGallery={isCheckedGallery}
      data-qa="reviews-photos-modal_mf-pdp"
      {...htmlProps}
    />
  );
};

const mapStoreToProps = (store: RootReducer): ReviewsPhotosModalState => {
  const openedFromGallery = isReviewsPhotosModalOpenedFromGallery(store);
  const photos = openedFromGallery ? getAllPhotosFromReviews(store) : getReviewsAllPhotos(store);

  return {
    photos,
    isShowed: isReviewsPhotosModalShowed(store),
    showedPicture: getReviewsPhotosModalCurrentShowed(store),
    nextPhotosPageIndex: getReviewsPhotosPagesCount(store),
    hasMorePhotos: photos.length >= REVIEWS_PHOTOS_PER_PAGE && getHasMoreReviewsPhotos(store),
    isCheckedGallery: openedFromGallery,
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onCloseModal: () => dispatch(closePhotosModal()),
  setShowedPicture: (pic: PictureSources | null) => dispatch(showPhoto(pic)),
  fetchNextPhotos: (currentPage: number) => dispatch(FETCH_REVIEWS_PHOTOS_PAGE.request({ currentPage })),
});

export const PdpReviewsPhotosModal = connect(mapStoreToProps, mapDispatchToProps)(ReviewsPhotosModal);
